import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import { MasterController } from './MasterController';
import { ApplicationItemComponent } from './applicationItem';
import MasterView from './MasterView.html';
export default angular
    .module('services', [])
    .component('applicationItem', ApplicationItemComponent)
    .controller('MasterController', MasterController)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('auth.application.detail.master', {
            url: '/template/master',
            redirectTo: 'auth.application.detail.master.index',
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: {
                area: 'basicConfigurations',
            },
        })
            .state('auth.application.detail.master.index', {
            url: '/',
            views: {
                'content@auth.application.detail': {
                    template: MasterView,
                    controller: MasterController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: {
                area: 'basicConfigurations',
            },
        });
    }]).name;
